type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'IpAllowed'
const nameSource = 'users/ipsAlloweds'
const namePageTitle = 'Ips Permitidos'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Ips Permitidos',
  to: '/users/ipsAlloweds',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/users/ipsAlloweds/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/users/ipsAlloweds/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/users/ipsAlloweds/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
